export interface ICurrentSchoolYear {
  START: string;
  END: string;
  LAST_DAY: string;
  ENDFULL: string;
  ENDFULL_VAL: number;
  STARTFULL: string;
  WITH_SY_PREFIX: string;
}

// TODO UPDATE AT TERM 1 FLIP: change values to reflect current school year
export const CurrentSchoolYear: ICurrentSchoolYear = {
  START: '20',
  END: '21',
  LAST_DAY: '2021-08-17',
  ENDFULL: '2021',
  ENDFULL_VAL: 2021,
  STARTFULL: '2020',
  WITH_SY_PREFIX: 'SY2020-21', // must follow this regex: ^SY20\d{2}-\d{2}$/g
};

export const getPastSchoolYearWithPrefix = (schoolYearWithPrefix: string, yearsPrior: number) => {
  const currentYear = parseInt(schoolYearWithPrefix.substring(7)); // last 2 digits
  const endYear = currentYear - yearsPrior;
  const startYear = endYear - 1;
  return `SY20${startYear}-${endYear}`;
};

export const OneYearPrior: ICurrentSchoolYear = {
  START: '19',
  END: '20',
  LAST_DAY: null,
  ENDFULL: null,
  ENDFULL_VAL: null,
  STARTFULL: null,
  WITH_SY_PREFIX: 'SY2019-20', // must follow this regex: ^SY20\d{2}-\d{2}$/g
};

export const TwoYearPrior: ICurrentSchoolYear = {
  START: '18',
  END: '19',
  LAST_DAY: null,
  ENDFULL: null,
  ENDFULL_VAL: null,
  STARTFULL: null,
  WITH_SY_PREFIX: 'SY2018-19', // must follow this regex: ^SY20\d{2}-\d{2}$/g
};
